import { useMemo } from 'react';
import { sprintf } from 'sprintf-js';

import { DropdownChevron } from 'components/Dropdown/Chevron/DropdownChevron';
import { DropdownHeaderTrigger } from 'components/Dropdown/HeaderTrigger/DropdownHeaderTrigger';
import { Hide } from 'components/Hide';
import { Icon } from 'components/Icon';
import { MyAccountDropdown } from 'components/MyAccountDropdown/MyAccountDropdown';
import { useLogin } from 'hooks/useLogin';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import {
  NOTIFICATIONS,
  NotificationStatus,
  useLocalNotifications,
} from 'utils/localNotifications';
import { hasResumeDb, promoteResumeDatabase } from 'utils/resumeDatabase';

export function MyAccountDropdownContainer() {
  const userEnvironment = useUserEnvironment();

  const { user } = userEnvironment;
  const displayName = user?.firstName || user?.email || '';

  const { localNotifications } = useLocalNotifications();

  const resumeNotification = useMemo(
    () =>
      localNotifications?.find(
        (notification) => notification.type === NOTIFICATIONS.UPLOAD_RESUME,
      ),
    [localNotifications],
  );

  const promoteResumeDb = useMemo(
    () =>
      resumeNotification?.status === NotificationStatus.NEW &&
      promoteResumeDatabase({ userEnvironment }),
    [resumeNotification, userEnvironment],
  );

  const { onClickLogin, loginLink } = useLogin();

  return (
    <MyAccountDropdown
      trigger={
        <DropdownHeaderTrigger
          variant="grey"
          qaId="nav-dropdown-toggle"
          ariaLabel={getText('Account Information')}
          onClick={() => {
            trackClicked('Header Utility CTA - Hi, Name');
          }}
        >
          <Hide lg xl>
            <Icon name="gear" size={20} />
          </Hide>

          <Hide xs sm md display="flex" alignItems="center">
            {
              /* TRANSLATORS: user greeting at top of page */
              sprintf(getText('Hi, %(name)s!'), { name: displayName })
            }

            <DropdownChevron />
          </Hide>
        </DropdownHeaderTrigger>
      }
      displayName={displayName}
      orgs={user?.orgs || []}
      promoteResumeDb={promoteResumeDb}
      showEmploymentProfileLink={hasResumeDb(userEnvironment)}
      hasResume={Boolean(user?.resumeId)}
      isLoggedIn={Boolean(user)}
      loginLink={loginLink}
      onClickLogin={onClickLogin}
    />
  );
}
